import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../lib/api';
import { PEOPLE_KEY } from './people';

export function useSendInvites() {
  return useMutation({
    mutationFn: (person_ids?: string[]) =>
      api<{ attempted: number; sent: number }>('/api/admin/onboarding/invite', {
        method: 'POST',
        body: JSON.stringify(person_ids ? { person_ids } : {}),
      }),
  });
}

export function useSendReminders() {
  return useMutation({
    mutationFn: (person_ids?: string[]) =>
      api<{ attempted: number; sent: number }>('/api/admin/onboarding/remind', {
        method: 'POST',
        body: JSON.stringify(person_ids ? { person_ids } : {}),
      }),
  });
}

export function useResendInvite() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) =>
      api<{ sent: boolean }>(`/api/admin/onboarding/people/${id}/resend-invite`, {
        method: 'POST',
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: PEOPLE_KEY }),
  });
}
